export enum CacheKeys {
  AUTHENTICATION = 'authentication',
  API_KEYS = 'apiKeys',
  LEGACY_API_KEYS = 'legacyApiKeys',
}
